define.alias("shared/utils/compare-strings", "media/utils/compare-strings");